<div class="operation-selector-vertical">
  <ul
    class="operation-selector-vertical__items"
    [ngClass]="{'smallScreen': smallScreen, 'edit': editContent}"
  >
    @for (operation of operationContainer.operations; track $index) {
      <ng-container>
        @if (!operation.hide_menu_bar) {
          <li
            class="operation-selector-vertical__item"
            [ngClass]="{'active': operation.$$operationSelected}"
          >
            <a
              class="operation-selector-vertical__item-content"
              [ngClass]="{'text-blue-hover': !editContent, 'disabled-operation': editContent}"
              [class.text-blue]="operation.$$operationSelected"
              [routerLink]="primusStateMapper.routerLinkFromState(currentState)"
              [queryParams]="primusStateMapper.queryParams({listName: operation.content_list})"
              queryParamsHandling="merge"
              (click)="setActiveOperation(operation)"
            >
              @if (operation.menu_icon | materialSymbol; as symbol) {
                <mat-icon
                  class="material-symbols-outlined"
                  aria-hidden="true"
                >{{ symbol }}</mat-icon>
              }
              @else {
                <i
                  class="{{operation.menu_icon}}"
                  aria-hidden="true"
                ></i>
              }

              <span>
                {{operation.menu_title | translate}}
              </span>
            </a>

            @if (operation.$$operationSelected) {
              <div class="operation-selector-vertical__vertical-line bg-blue"></div>
            }
          </li>
        }
      </ng-container>
    }
  </ul>

  <div class="operation-selector-vertical__remaining-space"></div>
</div>

